<template>
  <div></div>
</template>
<script>
import helpers from "@/helpers"
import { baseApiUrl } from "@/global"
import axios from "axios"
import imgToBase64 from "image-to-base64"

import pdfmake from "pdfmake"
import pdffonts from "pdfmake/build/vfs_fonts.js"

export default {
  data() {
    return {
      boxes: [],
      importation: [],
      packingList: [],
      selectedProducts: [],
      selectedProductsSanitized: []
    }
  },
  methods: {
    async generate(idImportation) {
      this.helpers = helpers

      if (!pdfmake.vfs) {
        pdfmake.vfs = pdffonts.pdfMake.vfs;
      }

      await this.getImportation(idImportation)
      await this.fixVarsToTable()
      if (!this.importation || !this.selectedProducts.length) return false
      await this.makePDF()
      return true
    },
    async getImportation(idImportation) {
      try {
        this.$vs.loading()
        const response = await axios.get(`${baseApiUrl}/importation/${idImportation}/packingList`)
        console.log(response);
        this.boxes = response.data.boxes
        this.importation = { ...response.data.importacoes, ...response.data.empresa }
        this.packingList = response.data.packingList
        this.selectedProducts = response.data.selectedProducts
      } catch (error) {
        this.$vs.notify({
          title: 'Não foi possivel gerar o arquivo',
          text: error.response.data,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    async fixVarsToTable() {
      const helpers = this.helpers
      const selectedProducts = this.selectedProducts
      const boxes = this.boxes
      const selectedProductsSanitized = []
      this.totalQuantity = 0
      this.importationNetWeight = 0
      let importationPrice = 0

      for (const box of boxes) {
        let firstItemOfBox = true
        const rowSpan = selectedProducts.filter(product => product.numeroCaixa == box.numeroCaixa).length
        for (const product of selectedProducts) {
          if (product.numeroCaixa != box.numeroCaixa) continue

          //valores que só existem no primeiro item de cada caixa
          const index = firstItemOfBox ? { text: box.numeroCaixa, alignment: "center", rowSpan } : {}
          const boxNetWeight = firstItemOfBox ? { text: box.pesoLiquido, alignment: "center", rowSpan } : {}
          const boxGrossWeight = firstItemOfBox ? { text: box.pesoBruto, alignment: "center", rowSpan } : {}
          const boxMeasures = firstItemOfBox ? { text: box.dimensoes, alignment: "center", rowSpan } : {}

          const totalPrice = (product.quantidade * product.precoMinimo).toFixed(2)
          const totalNetWeight = (product.quantidade * product.pesoLiquido).toFixed(3)

          this.totalQuantity += product.quantidade
          this.importationNetWeight += +totalNetWeight
          importationPrice += +totalPrice

          selectedProductsSanitized.push([
            index,
            { text: product.fk_idProduto, noWrap: true },
            { text: product.descricaoEN, noWrap: true },
            { text: product.marca, alignment: "center" },
            { text: product.modelo },
            { text: product.ncm, alignment: "center" },
            { text: product.quantidade, alignment: "center" },
            { text: product.unidade, alignment: "center" },
            { text: (+product.pesoLiquido).toFixed(3), alignment: "center" },
            { text: totalNetWeight, alignment: "center" },
            boxNetWeight,
            boxGrossWeight,
            boxMeasures
          ])
          firstItemOfBox = false
        }
      }

      //ultima linha
      selectedProductsSanitized.push([
        { text: '', border: [true, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        {
          text: this.totalQuantity,
          bold: true,
          alignment: "center",
          border: [false, false, false, false]
        },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        {
          text: this.importationNetWeight.toFixed(3),
          alignment: "center",
          bold: true,
          border: [false, false, false, false]
        },
        {
          text: this.importationNetWeight.toFixed(3),
          alignment: "center",
          bold: true,
          border: [false, false, false, false]
        },
        {
          text: this.packingList.totalPesoBruto + ' KG',
          alignment: "center",
          bold: true,
          noWrap: true,
          border: [false, false, false, false]
        },
        {
          text: `${this.packingList.totalMedida} m³`,
          alignment: "center",
          bold: true,
          border: [false, false, true, false]
        },
        // {
        //   text: helpers.moneyHelper.formatNumberToCurrency(importationPrice, selectedProducts[0].moeda),
        //   bold: true,
        //   alignment: "center",
        //   border: [false, false, true, false]
        // }
      ])
      this.selectedProductsSanitized = selectedProductsSanitized
      await this.setVariablesValues()
    },
    async setVariablesValues() {
      const stampAndSignature = []
      const packingListInfo = []

      // if (this.importation.mostrarCarimbo) {
      //   stampAndSignature.push([{
      //     relativePosition: { x: 400, y: 95 },
      //     text: 'Stamp and Signature',
      //     border: [true, false, true, false]
      //   }])
      //   stampAndSignature.push([{
      //     relativePosition: { x: 387, y: 28 },
      //     image: 'data:image/jpeg;base64,' + (await imgToBase64('https://regnaparts.s3-sa-east-1.amazonaws.com/images/carimbo2.png')),
      //     width: 70,
      //     border: [true, false, true, false],
      //   }])
      // }

      if (this.packingList.totalCaixas) {
        packingListInfo.push([{
          text: `TOTAL VOLUMS: ${this.packingList.totalCaixas}`,
          border: [true, false, true, false],
        }])
      }
      if (this.packingList.totalPesoBruto) {
        packingListInfo.push([{
          text: `TOTAL GROSS WEIGHT: ${this.packingList.totalPesoBruto}KG`,
          border: [true, false, true, false],
        }])
      }
      if (this.packingList.totalMedida) {
        packingListInfo.push([{
          text: `CMB: ${this.packingList.totalMedida} m³`,
          border: [true, false, true, false],
        }])
      }

      this.stampAndSignature = stampAndSignature
      this.packingListInfo = packingListInfo
    },
    async makePDF() {
      const importation = this.importation
      const title = `${importation.numeroImportacao} IMPORTAÇÃO ${importation.nomeCurto} - PACKING LIST`
      const dataPedido = this.helpers.dateHelper.formatDateToPTBR(importation.data_pedido)
      let docDefinition = {
        info: {
          title,
        },
        content: [{
            margin: [0, 0, 0, -1],
            table: {
              widths: ['*'],
              body: [
                [{ text: 'NINGBO HAISHU DAFENG TRADING CO., LTD.', alignment: "center" }],
                [{ text: 'BUILDING 13, ROOM 803, WANGCHUN, WUJIANGWAN BEIQU, NINGBO, ZIP 315016 - CHINA', alignment: "center", margin: [0, -4, 0, 0] }],
                [{ text: 'PACKING LIST', bold: true, alignment: "center", margin: [0, -4, 0, 0] }],
                [{
                  text: ['SELL TO: ', { text: importation.razaoSocial, bold: true }]
                }]
              ]
            },
            layout: {
              hLineColor: function(i, node) {
                return (i === 0 || i === node.table.body.length || i == node.table.body.length - 1) ? 'black' : 'white';
              },
            }
          },
          {
            margin: [0, 0, 0, -1],
            table: {
              widths: ['30%', '20%', '18%', '15%', '17%'],
              body: [
                [
                  { text: `ADDRESS: ${importation.endereco}`, border: [true, true, false, false], margin: [0, 2, 0, 0] },
                  { text: `BAIRRO: ${importation.bairro}`, colSpan: 3, border: [false, true, true, false], margin: [0, 2, 0, 0] }, '', '',
                  { text: `INVOICE N°: ${importation.codigoInvoice}`, margin: [0, 2, 0, 1] }
                ],
                [
                  { text: `ATTN: ${importation.attn}`, border: [true, false, false, true], margin: [0, 0, 0, 1] },
                  { text: `TEL: ${importation.telefone}`, border: [false, false, false, true], margin: [0, 0, 0, 1] },
                  { text: `CNPJ: ${importation.cnpj}`, border: [false, false, false, true], margin: [0, 0, 0, 1] },
                  { text: `CEP: ${importation.cep}`, border: [false, false, true, true], margin: [0, 0, 0, 1] },
                  { text: `DATE: ${dataPedido}`, margin: [0, 1, 0, 1] }
                ]
              ]
            },
            layout: {
              paddingTop: () => { return 0 },
              paddingBottom: () => { return 0 }
            }
          },
          {
            margin: [0, 0, 0, 5],
            table: {
              widths: ['50%', '50%'],
              body: [
                [{
                    stack: [
                      { text: 'SHIPMENT', alignment: "center" },
                      { text: 'NINGBO - CHINA', alignment: "center" }
                    ]
                  },
                  {
                    stack: [
                      { text: 'PORT OF DESTINATION', alignment: "center" },
                      { text: 'PORTO ALEGRE', alignment: "center" }
                    ]
                  },
                ],
                [{
                    stack: [
                      { text: 'DATE OF SHIPMENT', alignment: "center" },
                      { text: dataPedido, alignment: "center" }
                    ]
                  },
                  {
                    stack: [
                      { text: 'MODE OF TRANSPORTATION', alignment: "center" },
                      { text: 'BY AIR', alignment: "center" }
                    ]
                  },
                ],
              ]
            },
          },
          {
            margin: [0, 0, 0, -3],
            table: {
              widths: ['auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 20, 35],
              dontBreakRows: true,
              body: [
                [{
                    text: 'BOX',
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: 'CODE',
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: 'DESCRIPTION',
                    alignment: "center",
                    bold: true
                  },
                  {
                    text: 'BRAND',
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: 'MODEL',
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: 'NCM',
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: "Q'TY",
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: 'UNIT',
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: 'NET WEIGHT\nUNIT/KG',
                    alignment: "center",
                    preserveLeadingSpaces: true,
                    bold: true
                  },
                  {
                    text: 'NET WEIGHT\nTOTAL/KG',
                    alignment: "center",
                    preserveLeadingSpaces: true,
                    bold: true
                  },
                  {
                    text: 'NET WEIGHT\nBOX/KG',
                    alignment: "center",
                    preserveLeadingSpaces: true,
                    bold: true
                  },
                  {
                    text: 'GROSS WEIGHT\nKG',
                    alignment: "center",
                    preserveLeadingSpaces: true,
                    bold: true
                  },
                  {
                    text: 'BOX MEASURES\nLxWxH',
                    alignment: "center",
                    preserveLeadingSpaces: true,
                    bold: true
                  }
                ],
                ...this.selectedProductsSanitized,
              ]
            },
            layout: {
              paddingTop: (ri, node) => {
                node.table.body[0].forEach((cell) => {
                  if (!cell.text.includes('\n'))
                    cell._margin = [0, 6, 0, 0]
                })
                return 1
              },
              paddingBottom: () => { return 1 }
            }
          },
          {
            table: {
              widths: ['*'],
              body: [
                ...this.stampAndSignature,
                [{ text: [{ text: 'Country of acquistion: ', bold: true }, 'China'], border: [true, false, true, false] }],
                [{ text: [{ text: 'Country of origin: ', bold: true }, 'China'], border: [true, false, true, false] }],
                [{ text: [{ text: 'Country of Provenance: ', bold: true }, 'China'], border: [true, false, true, false] }],
                [{ text: 'Lijia Bridge, Buzheng South Door, Cidade Ningbo, Província Zhejiang - CN', border: [true, false, true, false] }],
                [{ text: "Manufacturer's Infomations:", decoration: 'underline', bold: true, border: [true, false, true, false] }],
                [{ text: 'NINGBO SEA-HILL PRINTER CONSUMABLE CO., LTD.', border: [true, false, true, false] }],
                [{ text: [{ text: 'Place of delivered: ', bold: true }, 'ROOM 311, LISHESANCHAKOU, YINZHOU, NINGBO, ZIP 315154 - CHINA'], border: [true, false, true, false] }],
                [{ text: ' ', border: [true, false, true, false] }],
                [{ text: `LOTE: ${importation.lote}`, bold: true, border: [true, false, true, false] }],
                [{ text: `TOTAL PIECES: ${this.totalQuantity}`, border: [true, false, true, false] }],
                [{ text: `TOTAL NET WEIGHT: ${this.importationNetWeight.toFixed(3)}KG`, border: [true, false, true, false] }],
                ...this.packingListInfo,
                [{ text: ' ', border: [true, false, true, false] }],
                [{ text: [{ text: 'Payment Terms: ', bold: true }, 'Advanced', ], border: [true, false, true, false] }],
                [{ text: ' ', border: [true, false, true, false] }],
                [{ text: `BANK NAME: DBS Bank (Hong Kong) Limited`, bold: true, border: [true, false, true, false] }],
                [{ text: `BANK ADDRESS: 11th Floor, The Center, 99 Queen's Road Central, Central, Hong Kong`, bold: true, border: [true, false, true, false] }],
                [{ text: `SWIFT/BIC Code: DHBKHKHH`, bold: true, border: [true, false, true, false] }],
                [{ text: `BENEFICIARY NAME: XT-NINGBO HAISHU DAFENG TRADING CO., LTD.`, bold: true, border: [true, false, true, false] }],
                [{ text: `Account No.: 79969236581`, bold: true, border: [true, false, true, true], margin: [0, 0, 0, 2] }],
              ]
            },
            layout: {
              paddingLeft: () => { return 1.5 },
              paddingTop: () => { return 0 },
              paddingBottom: () => { return 0 }
            }
          },
        ],
        defaultStyle: {
          fontSize: 5,
        },
        pageMargins: [20, 20],
        // pageOrientation: 'landscape',
      }
      pdfmake.createPdf(docDefinition).open()
    }
  },
}

</script>
